<script>
import axios from 'axios';
import ImageGalleryModal from './ImageGalleryModal.vue';
import ImageGallerySearch from './ImageGallerySearch.vue';
import ImageGalleryShowMore from './ImageGalleryShowMore.vue';
import MasonryWall from '@yeger/vue-masonry-wall';

export default {
  props: [
    'epiDivClass',
    'heading',
    'preamble',
    'queryString',
    'columns',
    'url',
    'disableSearch',
    'totalImages',
  ],
  components: {
    ImageGalleryModal,
    ImageGallerySearch,
    ImageGalleryShowMore,
    MasonryWall,
  },
  data: () => ({
    loading: true,
    images: null,
    errored: false,
    modalVisible: false,
    modalData: null,
    query: null,
    showMoreItems: 0,
    noResponse: false,
  }),
  methods: {
    async showMore() {
      axios
        .post(this.url + '/' + this.increment)
        .then((response) => {
          if (response.data.query.length == 0) {
            this.noResponse = true;
          }

          for (var i = 0; i < response.data.query.length; i++) {
            this.images.push(response.data.query[i]);
          }
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
      this.increment += parseInt(this.totalImages);
    },
    async init() {
      axios
        .post(this.url)
        .then((response) => {
          this.images = response.data.query;
        })
        .catch((error) => {
          console.log(error);
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    toggleModal(data) {
      this.modalData = data;
      this.modalVisible = true;
    },
    filterImages(query) {
      if (query.length) {
        this.showMoreItems = true;
        this.query = query;
      } else {
        this.query = null;
      }
    },
    totalImagesToShow: function () {
      if (!this.showMoreItems) {
        return +this.totalImages;
      } else {
        return +this.totalImages + this.showMoreItems;
      }
    },
  },
  computed: {
    amount() {
      return this.images?.length || 0;
    },
    showSearch() {
      const search = this.disableSearch;
      if (search && search.length) {
        if (search === 'False' || search == 'false' || search == false) {
          return true;
        } else if (search === 'True' || search == 'true' || search == true) {
          return false;
        }
      }
      return true;
    },
    filteredImages() {
      if (this.query && this.query.length) {
        const result = this.images.filter((arrayItem) => {
          return arrayItem.find(
            (item) =>
              item.name
                .toLowerCase()
                .trim()
                .includes(this.query.toLowerCase().trim()) ||
              item.metaData.find((val) =>
                val.Value.toLowerCase()
                  .trim()
                  .includes(this.query.toLowerCase().trim())
              )
          );
        });
        return result.filter((el, index) => index < 10000);
      }
      return this.images && this.images.length
        ? this.images.filter((el, index) => index < 10000)
        : false;
    },
  },
  async created() {
    await import(
      /* webpackChunkName: "forms" */ '../../../static/js/loaders/forms.js'
    );
    this.init();
    this.increment = parseInt(this.totalImages);
  },
};
</script>

<template>
  <div class="image-gallery-block-container vld-parent">
    <ImageGalleryModal
      v-if="modalVisible"
      @close="(modalVisible = false), (modalData = null)"
      :data="modalData" />

    <div class="d-flex align-items-center justify-content-center">
      <vloading
        :height="42"
        :width="42"
        :color="'#404040'"
        :is-full-page="false"
        :active.sync="loading"></vloading>
    </div>

    <section v-if="errored">
      <p>
        We're sorry, we are not able to retrieve this information at the moment,
        please try later
      </p>
    </section>

    <section v-else>
      <div class="image-gallery-block-header">
        <h2 v-if="heading">{{ heading }}</h2>
        <p class="image-gallery-block-header_text" v-if="preamble">
          {{ preamble }}
        </p>
        <ImageGallerySearch
          v-if="showSearch"
          @submitted="filterImages"
          :text="'Sök efter bilder'" />
      </div>

      <div class="image-gallery-block-hits">
        <template v-if="totalImages && !showMoreItems">
          <transition name="fade" mode="in-out">
            <p v-if="filteredImages && filteredImages.length">
              Visar <strong>{{ amount }}</strong> bilder
            </p>
            <p v-else>Inga träffar!</p>
          </transition>
        </template>
        <template v-else>
          <transition name="fade" mode="in-out">
            <p v-if="filteredImages && filteredImages.length">
              Visar <strong>{{ amount }}</strong> bilder
            </p>
            <p v-else>Inga träffar!</p>
          </transition>
        </template>
      </div>

      <template
        v-if="
          images && images.length && filteredImages && filteredImages.length
        ">
        <MasonryWall
          :items="filteredImages"
          :ssr-columns="1"
          :column-width="270"
          :gap="10"
          class="image-gallery-block">
          <template #default="{ item, index }">
            <button @click="toggleModal(item)" class="image-gallery-block-item">
              <div
                v-if="item[0].metaData && item[0].metaData[0].Value"
                class="image-gallery-block-item-image-info">
                {{ item[0].metaData[0].Value }}
              </div>
              <img
                v-if="item[0].imageUrl"
                class="image-gallery-block-item-image"
                :src="item[0].imageUrl"
                :alt="item[0].id" />
            </button>
          </template>
        </MasonryWall>
      </template>
      <ImageGalleryShowMore @show-more="showMore" v-if="!noResponse" />
    </section>
  </div>
</template>
